import ModalEditPriceRoom from './ModalEditPriceRoom.container';

export default ModalEditPriceRoom;
